/* eslint-disable max-classes-per-file */
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { Collection, IViolation } from '../base/annotation';
import { A365Named } from '../base/a365Named';
import { ModelConstants } from '../model-constants';
import { ActionConstants } from '../../constants/action-constants';
import { getGeneralNamePatterns } from '../../shared/utils/validation.util';
import { SparkConfiguration } from '../sparkconfiguration/sparkconfiguration';

@Metamodel.model({
    name: 'Notebook Cell Metadata'
})
export class NbCellMetadata {
    @Metamodel.attribute({
    })
    public collapsed?: boolean;

    @Metamodel.attribute({
    })
    public scrolled?: boolean | 'auto';

    @Metamodel.attribute({
    })
    public deletable?: boolean;

    @Metamodel.attribute({
    })
    public format?: string;

    @Metamodel.attribute({
    })
    public name?: string;

    @Metamodel.attribute({
    })
    public tags?: string[];

    @Metamodel.attribute({
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public customMetadata?: { [name: string]: any };
}

@Metamodel.model({
    name: 'Notebook Cell'
})
export class NbCell {
    @Metamodel.attribute({
    })
    public cellType: string;

    @Metamodel.attribute({
    })
    public metadata: NbCellMetadata;

    @Metamodel.attribute({
    })
    public source: string | string[];

    @Metamodel.attribute({
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public attachments?: { [name: string]: any };
}

@Metamodel.model({
    name: 'Notebook Code Cell Output'
})
export class NbCodeCellOutputBase {

    @Metamodel.attribute({
    })
    public outputType: string;
}

@Metamodel.model({
    name: 'Notebook Code Cell Stream Output'
})
export class NbCodeCellStreamOutput extends NbCodeCellOutputBase {

    @Metamodel.attribute({
    })
    public name: 'stdout' | 'stderr';

    @Metamodel.attribute({
    })
    public outputType: 'stream' = 'stream';

    @Metamodel.attribute({
    })
    public text: string | string[];
}

@Metamodel.model({
    name: 'Notebook Code Display Output'
})
export class NbCodeCellDisplayDataOutput extends NbCodeCellOutputBase {
    @Metamodel.attribute({
    })
    public outputType: 'display_data' = 'display_data';

    @Metamodel.attribute({
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public data: any;

    @Metamodel.attribute({
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public metadata?: any;
}

@Metamodel.model({
    name: 'Execute Result'
})
export class NbCodeCellExecuteResultOutput extends NbCodeCellOutputBase {
    @Metamodel.attribute({
    })
    public outputType: 'execute_result' = 'execute_result';

    @Metamodel.attribute({
    })
    public executionCount: number;

    @Metamodel.attribute({
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public data: any;

    @Metamodel.attribute({
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public metadata?: any;
}

@Metamodel.model({
    name: 'Notebook Cell Error Output'
})
export class NbCodeCellErrorOutput extends NbCodeCellOutputBase {
    @Metamodel.attribute({
    })
    public outputType: 'error' = 'error';

    @Metamodel.attribute({
    })
    public ename: string;

    @Metamodel.attribute({
    })
    public evalue: string;

    @Metamodel.attribute({
    })
    public traceback: string[];
}

@Metamodel.model({
    name: 'Notebook Code Cell'
})
export class NbCodeCell extends NbCell {
    @Metamodel.attribute({
    })
    public cellType: 'code' = 'code';

    @Metamodel.attribute({
    })
    public outputs: NbCodeCellOutputBase[];

    @Metamodel.attribute({
    })
    public executionCount: number;
}

@Metamodel.model({
    name: 'Notebook Language info'
})
export class NbLanguageInfo {
    @Metamodel.attribute({
        display: 'name',
        constraint: {
            required: true
        }
    })
    public name: string;

    @Metamodel.attribute({
        display: 'version'
    })
    public version: string;

    @Metamodel.attribute({
        display: 'codemirror_mode'
    })
    public codemirrorMode: string;
}

@Metamodel.model({
    name: 'Notebook Kernel info'
})
export class NbKernelInfo {
    @Metamodel.attribute({
        display: 'name',
        constraint: {
            required: true
        }
    })
    public name: string;

    @Metamodel.attribute({
        display: 'name',
        constraint: {
            required: true
        }
    })
    public displayName: string;
}

@Metamodel.model({
    name: 'Notebook content'
})
export class NbMetadata {
    @Metamodel.attribute({
    })
    public languageInfo: NbLanguageInfo;

    @Metamodel.attribute({
    })
    public kernelInfo?: NbKernelInfo;

    @Metamodel.attribute({
    })
    public authors?: NbAuthor[];

    @Metamodel.attribute({
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public customMetadata?: { [name: string]: any };
}

@Metamodel.model({
    name: 'Compute Auth'
})
export class NbComputeAuth {
    @Metamodel.attribute({
    })
    public computeAuthType: string;

    @Metamodel.attribute({
    })
    public authResource?: string;

    @Metamodel.attribute({
    })
    public authHeader?: string;
}

@Metamodel.model({
    name: 'Notebook Compute Session Properties'
})
export class NbComputeSessionProperties {
    @Metamodel.attribute({
    })
    public driverMemory: string;

    @Metamodel.attribute({
    })
    public driverCores: number;

    @Metamodel.attribute({
    })
    public executorMemory: string;

    @Metamodel.attribute({
    })
    public executorCores: number;

    @Metamodel.attribute({
    })
    public numExecutors: number;

    @Metamodel.attribute({
    })
    public conf?: {
        [key: string]: string;
    };
    @Metamodel.attribute({})
    public runAsWorkspaceSystemIdentity?: boolean;
}

@Metamodel.model({
    name: 'Notebook Compute Options'
})
export class NbComputeOptions {
    @Metamodel.attribute({
    })
    public id: string;

    @Metamodel.attribute({
    })
    public computeType: string;

    @Metamodel.attribute({
    })
    public name: string;

    @Metamodel.attribute({
    })
    public endpoint: string;

    @Metamodel.attribute({
    })
    public auth: NbComputeAuth;

    @Metamodel.attribute({
    })
    public sparkVersion: string;

    @Metamodel.attribute({
    })
    public nodeCount: number;

    @Metamodel.attribute({
    })
    public cores: number;

    @Metamodel.attribute({
    })
    public memory: number;

    @Metamodel.attribute({
    })
    public extraParams?: string;

    @Metamodel.attribute({
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public extraHeader?: any;

    @Metamodel.attribute({
    })
    public automaticScaleJobs?: boolean;
}

@Metamodel.model({
    name: 'A365 Notebook Metadata'
})
export class NbMetadataA365Specific extends NbMetadata {
    public computeOptions?: NbComputeOptions;
    public sessionOptions?: NbComputeSessionProperties;
    public sessionKeepAliveTimeout?: number;
    public targetSparkConfiguration?: string;
}

@Metamodel.model({
    name: 'Author'
})
export class NbAuthor {
    @Metamodel.attribute({
    })
    public name: string;
}

@Metamodel.model({
    name: ModelConstants.notebook,
    display: [shellStringResources.NotebookActivityLabel, shellStringResources.SynapseNotebooks],
    reusable: true,
    referable: true,
    validator: Notebook.validate,
    constraints: {
        name: {
            required: true,
            patterns: getGeneralNamePatterns(shellStringResources.NotebookActivityLabel),
            uniqueModelName: true
        }
    },
    accessPublishConstraint: {
        writeResource: {
            action: ActionConstants.notebooksWrite
        },
        deleteResource: {
            action: ActionConstants.notebooksDelete
        }
    }
})
export class Notebook extends A365Named {
    public readonly useShellFolder: boolean = true;

    @Metamodel.attribute({
        display: 'bigDataPool'
    })
    public bigDataPool?: string;

    @Metamodel.attribute({
        display: shellStringResources.ApacheSparkConfiguration,
        type: SparkConfiguration.MODEL,
        reference: true
    })
    public targetSparkConfiguration?: SparkConfiguration;

    @Metamodel.attribute({
        display: 'sessionProperties'
    })
    public sessionProperties?: NbComputeSessionProperties;

    @Metamodel.attribute({
        display: 'libraries',
        collection: Collection.Set
    })
    public libraries?: string[];

    @Metamodel.attribute({
        display: 'nbformat',
        constraint: {
            required: false,
            whole: true,
            minimum: 0
        }
    })
    public nbformat?: number;

    @Metamodel.attribute({
        display: 'nbformat_minor',
        constraint: {
            required: false,
            whole: true,
            minimum: 0
        }
    })
    public nbformatMinor?: number;

    @Metamodel.attribute({
        display: 'metadata'
    })
    public metadata?: NbMetadataA365Specific;

    @Metamodel.attribute({
        collection: Collection.Array
    })
    public cells?: NbCell[] = [];

    public violations: string[];

    // wheter fetched the contents of notebook that publised before the notebook has been opend.
    public hasFetchedCompletely = false;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static validate(owner: any): IViolation[] | undefined {
        const named = (owner && owner.named) as Notebook;
        if (named && named.violations) {
            return named.violations.map((violation) => ({
                context: owner,
                message: () => violation
            }));
        }

        return undefined;
    }
}
